// src/pages/AuditoriaChat.js
import { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "./AuditoriaChat.css";
import logo from "../assets/logo_auditoria.png";

export default function AuditoriaChat() {
  const [logs, setLogs] = useState([]);
  const [filtro, setFiltro] = useState({ cliente: "", comercio: "", fecha: "", conversacion: "" });

  useEffect(() => {
    fetch("https://lagora.chat/panelcomerciantes/api/getChatLogs.php")
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.logs)) {
          setLogs(data.logs);
        } else {
          console.error("Formato de datos incorrecto", data);
        }
      })
      .catch(err => {
        console.error("Error al cargar logs:", err);
      });
  }, []);

  const logsFiltrados = logs.filter(log => {
    return (
      (!filtro.cliente || log.nombre_cliente?.toLowerCase().includes(filtro.cliente.toLowerCase())) &&
      (!filtro.comercio || log.nombre_comercio?.toLowerCase().includes(filtro.comercio.toLowerCase())) &&
      (!filtro.fecha || log.fecha?.toLowerCase().includes(filtro.fecha.toLowerCase())) &&
      (!filtro.conversacion || log.conversacion_id?.toLowerCase().includes(filtro.conversacion.toLowerCase()))
    );
  });

  const exportarTXT = () => {
    if (logsFiltrados.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const texto = logsFiltrados.map(log =>
      `Fecha: ${log.fecha}\nCliente: ${log.nombre_cliente}\nComercio: ${log.nombre_comercio}\nMensaje: ${log.mensaje_cliente}\nRespuesta: ${log.respuesta_asistente}\nID Conversación: ${log.conversacion_id}\n\n`
    ).join("");

    const blob = new Blob([texto], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "conversaciones.txt";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportarCSV = () => {
    if (logsFiltrados.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const encabezados = ["Fecha", "ID Conversación", "Cliente", "Comercio", "Mensaje Cliente", "Respuesta Asistente"];
    const filas = logsFiltrados.map(log => [
      log.fecha,
      log.conversacion_id,
      log.nombre_cliente,
      log.nombre_comercio,
      log.mensaje_cliente.replace(/\n/g, " "),
      log.respuesta_asistente.replace(/\n/g, " ")
    ]);

    const csv = [encabezados, ...filas].map(row => row.map(cell => `"${cell}"`).join(",")).join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "conversaciones.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportarPDF = () => {
    if (logsFiltrados.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const doc = new jsPDF();
    let y = 50; // más separación desde el encabezado

    const img = new Image();
    img.src = logo;

    img.onload = () => {
      doc.addImage(img, "PNG", 10, 10, 30, 15);
      doc.setFontSize(14);
      doc.text("Informe de Conversaciones del Asistente Virtual", 45, 20);
      doc.setFontSize(11);
      doc.setTextColor(40);

      logsFiltrados.forEach((log, index) => {
        const bloque = [
          `Fecha: ${log.fecha}`,
          `Cliente: ${log.nombre_cliente || "-"}`,
          `Comercio: ${log.nombre_comercio || "-"}`,
          `Mensaje: ${log.mensaje_cliente}`,
          `Respuesta: ${log.respuesta_asistente}`,
          
        ];

        if (y + bloque.length * 6 > 280) {
          doc.addPage();
          y = 20;
        }

        bloque.forEach((linea, i) => {
          doc.text(linea, 10, y + i * 6, { maxWidth: 190 });
        });

        y += bloque.length * 6 + 6; // menos separación entre conversaciones
      });

      doc.save("conversaciones.pdf");
    };
  };

  return (
    <div className="auditoria-container">
      <h1>Auditoría de Conversaciones</h1>

      <div className="recuadro-informativo">
        🧠 Este sistema guarda las conversaciones con los clientes en la base de datos.
        Se elimina automáticamente cada cierto tiempo gracias al CRON configurado en Hostinger.
      </div>

      <div className="filtros-auditoria">
        <input placeholder="Filtrar por cliente" value={filtro.cliente} onChange={e => setFiltro(prev => ({ ...prev, cliente: e.target.value }))} />
        <input placeholder="Filtrar por comercio" value={filtro.comercio} onChange={e => setFiltro(prev => ({ ...prev, comercio: e.target.value }))} />
        <input placeholder="Filtrar por fecha" value={filtro.fecha} onChange={e => setFiltro(prev => ({ ...prev, fecha: e.target.value }))} />
        <input placeholder="Filtrar por ID conversación" value={filtro.conversacion} onChange={e => setFiltro(prev => ({ ...prev, conversacion: e.target.value }))} />
        <button onClick={exportarTXT}>📄 Exportar TXT</button>
        <button onClick={exportarCSV}>📊 Exportar CSV</button>
        <button onClick={exportarPDF}>🧾 Exportar PDF</button>
      </div>

      <table className="tabla-auditoria">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>ID Conversación</th>
            <th>Cliente</th>
            <th>Comercio</th>
            <th>Mensaje Cliente</th>
            <th>Respuesta Asistente</th>
          </tr>
        </thead>
        <tbody>
          {logsFiltrados.map((log) => (
            <tr key={log.id}>
              <td>{log.fecha}</td>
              <td>{log.conversacion_id || "-"}</td>
              <td>{log.nombre_cliente || "-"}</td>
              <td>{log.nombre_comercio || "-"}</td>
              <td>{log.mensaje_cliente}</td>
              <td>{log.respuesta_asistente}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}



